export default __webpack_public_path__ + "static/treatmentareas-hands-1pic-b14cbc92ea87216cf98a35962877c48f.webp";